__webpack_require__.p = "https://static.age.awaze.com/search-mfe/aa2f2be/_next/";